import { useTranslation } from 'react-i18next';
import {
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography
} from '@mui/material';
import MainCard from 'components/cards/MainCard';
import { useAppSelector } from 'hooks/useAppStore';
import {
  selectAccountInfo,
  selectSelectedEmsMemberAccount
} from 'features/account/accountSelectors';
import { GRID_SPACING } from 'utils/constants';
import Timer from 'components/timer/Timer';
import Logo from 'components/layout/MainLayout/Header/LogoSection/Logo';
import useUserGroupNames from 'hooks/useUserGroupNames';

const tableSX = {
  '& td': {
    borderBottom: 'none'
  }
};

const HomePage = () => {
  const { t } = useTranslation();

  const accountInfo = useAppSelector(selectAccountInfo);
  const selectedEmsMemberAccount = useAppSelector(
    selectSelectedEmsMemberAccount
  );
  const userGroupNames = useUserGroupNames(accountInfo?.userGroups);

  const rows = [
    {
      name: t(`module.homePage.emsPartyName`),
      value: selectedEmsMemberAccount?.emsPartyName
    },
    {
      name: t(`module.homePage.accountType`),
      value: selectedEmsMemberAccount?.accountType
        ? t(
            `module.eai.codebooks.${selectedEmsMemberAccount?.accountType}.title`
          )
        : ''
    },
    {
      name: t(`module.homePage.roles`),
      value: userGroupNames
    }
  ];

  return (
    <MainCard title={t(`module.homePage.title`)}>
      <Grid container spacing={GRID_SPACING}>
        <Grid container item xs={12} justifyContent={'space-between'}>
          <Grid item xs={6}>
            <TableContainer>
              <Table sx={tableSX} size='small'>
                <TableBody>
                  {rows.map((row) => (
                    <TableRow key={row.name}>
                      <TableCell variant='head'>{`${row.name}:`}</TableCell>
                      <TableCell>{row.value}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={4}>
            <TableContainer>
              <Table sx={tableSX} size='small'>
                <TableBody>
                  <TableRow key={t(`module.homePage.date`)}>
                    <TableCell variant='head'>
                      {`${t(`module.homePage.dateTime`)}:`}
                    </TableCell>
                    <TableCell>
                      <Timer />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Typography variant='body1'>
            {`${t(`module.homePage.AIEMSDescription`)}`}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant='body1'>
            {`${t(`module.homePage.appDescription`)}`}
          </Typography>
        </Grid>
        <Grid container item xs={12} justifyContent={'center'}>
          <Logo isLarge={true} />
        </Grid>
      </Grid>
    </MainCard>
  );
};
export default HomePage;
